import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';
import { delay } from 'bog-arcade-core-ui/helpers';

export class NumberGrowService {
  constructor({ min, max, stepDelay = .1, delay = 3 }) {
    this.min = min;
    this.max = max;
    this.stepDelay = stepDelay;
    this.delay = delay;
    this.value = new BehaviorSubject(this.min || 0);
    this.step = Math.floor((max - min) / (delay / stepDelay)) || 1;
  }

  subscribe(callback) {
    return this.value.subscribe(callback);
  }

  stop() {
    this.value.next(this.max);
  }

  start() {
    const val = this.value.getValue() + this.step;
    if (val >= this.max) {
      this.value.next(this.max);
      return;
    }
    if (this.value.getValue() === this.max) {
      return;
    }
    this.value.next(val);
    delay(() => {
      this.start();
    }, this.stepDelay * 1000);
  }

  get ended() {
    return this.value.getValue() === this.max;
  }
}